<template>
  <md-button
    class="md-simple"
    @click.native="changeMySelectedApp()"
    data-tour="change"
  >
    <md-icon>edit</md-icon>
    Change
  </md-button>
</template>
<script>
import swal from "sweetalert2";
import { get } from "vuex-pathify";
import { globalSelectedApp, changeSelectedApp } from "../utils/global";
export default {
  data() {
    return {
      selectedApp: null
    };
  },
  computed: {
    apps: get("applications/entities") || []
  },
  created() {
    this.$store.dispatch("applications/loadEntities").then(() => {
      if (globalSelectedApp != null) {
        this.selectedApp = globalSelectedApp;
      } else if (this.apps[0]) {
        this.selectedApp = this.apps[0];
      }
    });
  },
  methods: {
    changeMySelectedApp: async function() {
      var me = this;
      const { value: appIndex } = await swal.fire({
        title: "Application Telemetry",
        input: "select",
        inputOptions: me.apps.map(a => {
          return a.tag || a.applicationId;
        }),
        inputPlaceholder: "Select an Application",
        showCancelButton: true,
        inputValidator: () => {
          return new Promise(resolve => {
            resolve();
          });
        }
      });
      if (this.apps[appIndex]) {
        this.selectedApp = this.apps[appIndex];
      }
      changeSelectedApp(this.selectedApp);
      this.$emit("update-selected-app", this.selectedApp);
    }
  }
};
</script>
